/** @format */

import React, {useContext} from 'react';

import {QuoteContext} from 'frontier-quoter';

import {
    DESIGN_QUOTER_STEP_LANDING,
    DESIGN_QUOTER_STEP_QUOTER,
    DESIGN_QUOTER_STEP_DESIGN_DIRECTION_DESIGN_STYLE,
    DESIGN_QUOTER_STEP_DESIGN_DIRECTION_COLOR_PREFERENCES,
    DESIGN_QUOTER_STEP_DESIGN_DIRECTION_BRAND_AND_PRODUCT
} from 'frontier-constants';

import DesignQuoterLanding from './design_quoter_landing';
import DesignQuoter from './design_quoter';
import DesignDirection from './design_direction';

export default function DesignQuoterContainer(props) {
    const ctx = useContext(QuoteContext);

    // TODO: UX would probably be better if this were handled by a router, but keeping it
    // simple for now.
    switch (ctx.designQuoterStep) {
        case DESIGN_QUOTER_STEP_LANDING:
            return <DesignQuoterLanding {...props} />;
        case DESIGN_QUOTER_STEP_QUOTER:
            return <DesignQuoter {...props} />;
        case DESIGN_QUOTER_STEP_DESIGN_DIRECTION_DESIGN_STYLE:
        case DESIGN_QUOTER_STEP_DESIGN_DIRECTION_BRAND_AND_PRODUCT:
        case DESIGN_QUOTER_STEP_DESIGN_DIRECTION_COLOR_PREFERENCES:
            return <DesignDirection {...props} />;
        default:
            throw new Error('invalid quoter step');
    }
}
